/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SupplierSearchField {
    SUPPLIER_NAME = 'supplier_name',
    SUPPLIER_NUMBER = 'supplier_number',
}
